import React, { useState, useEffect } from "react";
import { Lock, Eye, EyeOff } from "lucide-react";

// Site password - change this to whatever you want
const SITE_PASSWORD = "Debbie@111125";

const PasswordGate = ({ children }) => {
  const [isUnlocked, setIsUnlocked] = useState(false);
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Check if already unlocked in this session
    const unlocked = sessionStorage.getItem("site_unlocked");
    if (unlocked === "true") {
      setIsUnlocked(true);
    }
    setIsLoading(false);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    setError("");

    if (password === SITE_PASSWORD) {
      sessionStorage.setItem("site_unlocked", "true");
      setIsUnlocked(true);
    } else {
      setError("Incorrect password. Please try again.");
      setPassword("");
    }
  };

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F8FEEE]">
        <div className="w-12 h-12 border-4 border-[#BEEF00] border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  if (isUnlocked) {
    return children;
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F8FEEE] p-4">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-2xl shadow-xl p-8 border border-[#E0E0E0]">
          {/* Logo */}
          <div className="text-center mb-8">
            <div className="flex items-center justify-center gap-2 mb-4">
              <span className="text-3xl font-bold text-[#1A5D1A]">Greenback</span>
              <div className="bg-[#1A5D1A] text-white p-1.5 rounded-lg">
                <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="2" y="6" width="20" height="12" rx="2"/>
                  <circle cx="12" cy="12" r="3"/>
                  <path d="M2 10h2M20 10h2M2 14h2M20 14h2"/>
                </svg>
              </div>
            </div>
          </div>

          {/* Lock Icon */}
          <div className="flex justify-center mb-6">
            <div className="w-16 h-16 bg-[#F8FEEE] rounded-full flex items-center justify-center">
              <Lock className="w-8 h-8 text-[#1A5D1A]" />
            </div>
          </div>

          {/* Title */}
          <h1 className="text-xl font-semibold text-center text-[#1A2E1A] mb-2">
            Private Preview
          </h1>
          <p className="text-center text-[#4A6B4A] text-sm mb-6">
            This site is currently in private beta. Enter the password to continue.
          </p>

          {/* Form */}
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter site password"
                className="w-full px-4 py-3 pr-12 border border-[#E0E0E0] rounded-xl focus:outline-none focus:ring-2 focus:ring-[#BEEF00] focus:border-transparent bg-white text-[#1A2E1A] placeholder-[#9CA3AF]"
                autoFocus
                data-testid="password-gate-input"
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-4 top-1/2 -translate-y-1/2 text-[#4A6B4A] hover:text-[#1A5D1A] transition-colors"
              >
                {showPassword ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
              </button>
            </div>

            {error && (
              <p className="text-red-500 text-sm text-center" data-testid="password-gate-error">
                {error}
              </p>
            )}

            <button
              type="submit"
              className="w-full py-3 bg-[#BEEF00] text-[#1A2E1A] font-semibold rounded-xl hover:bg-[#A8D900] transition-colors"
              data-testid="password-gate-submit"
            >
              Enter Site
            </button>
          </form>

          {/* Footer */}
          <p className="text-center text-xs text-[#9CA3AF] mt-6">
            Contact the site owner if you need access.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PasswordGate;
